import axios from 'axios'
import { ApiErrorResponse } from '@/services/api/client'

export interface ErrorContext {
  loadError: string
  saveError?: string
  permissionError?: string
  networkError?: string
}

export function extractErrorMessage(err: unknown, context: ErrorContext): string {
  if (err instanceof ApiErrorResponse) {
    if (err.statusCode === 403) return context.permissionError || context.loadError
    if (err.statusCode === 404) return err.detail || context.loadError
    if (err.statusCode === 400) {
      const data = err.response?.data as { details?: string[] } | undefined
      const details = data?.details
      if (details && details.length > 0) return `${err.detail}: ${details.join(', ')}`
      return err.detail
    }
    if (err.statusCode >= 500) {
      const data = err.response?.data as { details?: string[] } | undefined
      const details = data?.details
      if (details && details.length > 0) return `${err.detail}: ${details.join(', ')}`
      return err.detail
    }
    return err.detail || context.loadError
  }

  if (axios.isAxiosError(err)) {
    if (err.code === 'ERR_NETWORK') return context.networkError || 'Server nicht erreichbar. Bitte prüfe deine Verbindung.'
    const response = err.response
    const status = response?.status
    const data = response?.data as { detail?: string; message?: string; details?: string[] } | undefined
    const serverDetail = data?.detail || data?.message
    const details = data?.details
    if (status === 403) return context.permissionError || context.loadError
    if (status === 404) return serverDetail || context.loadError
    if (status === 400) {
      if (details && details.length > 0) return `${serverDetail || context.loadError}: ${details.join(', ')}`
      return serverDetail || context.loadError
    }
    if (status && status >= 500) return serverDetail || 'Serverfehler. Bitte versuche es spater erneut.'
    if (serverDetail) return serverDetail
    return context.loadError
  }

  if (err instanceof Error) return err.message
  return context.loadError
}

/** Fallakte: 409-Konflikt (anderer Direktor / bereits gebucht) — nicht 400 «bereits vergeben». */
export function isDirectorDecisionConflict(err: unknown): boolean {
  if (err instanceof ApiErrorResponse) return err.statusCode === 409
  if (axios.isAxiosError(err)) return err.response?.status === 409
  return false
}
